<template>
  <div class="background">
    <div class="container vw-100 d-flex py-3" style="min-height: 100vh">
      <div
        autocomplete="off"
        class="row justify-content-center align-items-center"
        style="width: 1100px"
      >
        <!-- <form class="bg-white col-md-9 p-4 rounded" @submit.stop.prevent="$validator.validateAll()"> -->
        <form class="bg-white col-md-9 p-4 rounded" @submit.stop.prevent="onSubmit">
          <div class="row">
            <div class="col p-3 text-center text-primary">
              <img :src="require('@/assets/img/logo.png')" width="100px" alt="" srcset="" />
              <p style="margin-bottom: 0%">Federal Ministry of</p>
              <h3 class="font-weight-bold" style="margin-bottom: 0%">HEALTH</h3>
            </div>
          </div>
          <div class="row">
            <div class="col text-center mb-4">
              <h4 class="h4 font-weight-bold text-muted">Activate Account</h4>
              <p class="text-muted">Accept invite and activate account</p>
            </div>
          </div>

          <div class="px-3 mb-3 row">
            <b-form-group
              label="First Name"
              label-for="first_name"
              class="text-dark font-weight-bold col-lg-6"
            >
              <b-form-input
                id="first_name"
                v-model="user.first_name"
                v-validate="'required'"
                data-vv-as="first name"
                name="first_name"
                type="text"
                class="form-control-lg"
                :state="validateState('first_name')"
              ></b-form-input>
              <b-form-invalid-feedback>{{ veeErrors.first("first_name") }}</b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              label="Last Name"
              label-for="last_name"
              class="text-dark font-weight-bold col-lg-6"
            >
              <b-form-input
                id="last_name"
                v-model="user.last_name"
                v-validate="'required'"
                data-vv-as="last name"
                name="last_name"
                type="text"
                class="form-control-lg"
                :state="validateState('last_name')"
              ></b-form-input>
              <b-form-invalid-feedback>{{ veeErrors.first("last_name") }}</b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              label="Username"
              label-for="username"
              class="text-dark font-weight-bold col-lg-6"
            >
              <b-form-input
                id="username"
                v-model="user.username"
                v-validate="'required'"
                data-vv-as="username"
                name="username"
                type="text"
                class="form-control-lg"
                :state="validateState('username')"
              ></b-form-input>
              <b-form-invalid-feedback>{{ veeErrors.first("username") }}</b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              label="Email address"
              label-for="email"
              class="text-dark font-weight-bold col-lg-6"
            >
              <b-form-input
                id="email"
                v-model="user.email"
                v-validate="'required|email'"
                name="email"
                type="email"
                placeholder=""
                class="form-control-lg"
                :state="validateState('email')"
                disabled
              ></b-form-input>
              <b-form-invalid-feedback>{{ veeErrors.first("email") }}</b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              label="New Password"
              label-for="password"
              class="text-dark font-weight-bold col-lg-6"
            >
              <b-form-input
                ref="password"
                v-model="user.password"
                v-validate="'required|min:6'"
                autocomplete="off"
                data-vv-as="Password"
                name="password"
                type="password"
                class="form-control-lg"
                :state="validateState('password')"
              ></b-form-input>
              <b-form-invalid-feedback>{{ veeErrors.first("password") }}</b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              label="Confirm Password"
              label-for="confirmPassword"
              class="text-dark font-weight-bold col-lg-6"
            >
              <b-form-input
                v-model="confirm_password"
                v-validate="'required|confirmed:password'"
                autocomplete="off"
                name="confirm_password"
                type="password"
                data-vv-as="confirm password"
                class="form-control-lg"
                :state="validateState('confirm_password')"
              ></b-form-input>
              <b-form-invalid-feedback>{{
                veeErrors.first("confirm_password")
              }}</b-form-invalid-feedback>
            </b-form-group>

            <div class="px-3 pt-2 col-12">
              <button type="submit" class="btn btn-primary btn-block btn-lg shadow">
                Activate
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import userResource from "../../api/userResource";

export default {
  data() {
    return {
      user: {
        first_name: "",
        last_name: "",
        username: "",
        email: "",
        password: "",
      },
      confirm_password: "",
    };
  },
  mounted() {
    // const userId = this.$route.query.id;
    // if (!userId) {
    //   this.$notify.error("Invalid Request");
    //   return this.$router.replace("/login");
    // }
    // userResource.get(userId).then((res) => {
    //   this.user = {
    //     ...this.user,
    //     ...res.data.user,
    //   }.catch((err) => {
    //     console.log(err);
    //     this.$notify.error("Unable to retrieve user information");
    //     return this.$router.replace("/login");
    //   });
    // });
  },
  methods: {
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    onSubmit() {
      const valid = this.$validator.validateAll();
      if (valid) {
        const token = this.$route.query.token;
        console.log(token);
        if (!token) {
          return this.$notify.error("Authentication Failed! Please contact admin.");
        }
        delete this.user.email;
        userResource
          .acceptInvite(token, this.user)
          .then(() => {
            this.$notify.success("Success, Kindly login to continue.");
            this.$router.replace("/login");
          })
          .catch((err) => {
            console.log(err);
            this.$notify.error("Request failed! Please contact admin.");
          });
      }
    },
  },
};
</script>
